import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/Contacto.css';

function Contacto() {
  // Estado para manejar los datos del formulario
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  // Cargar el script de Google reCAPTCHA al montar el componente
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Limpiar el script si el componente se desmonta
    };
  }, []);

  // Manejar el envío del formulario
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    message: '',
  });

  // Manejar el cambio en los inputs del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Validar los campos del formulario
  const validateForm = () => {
    let valid = true;
    let errorsTemp = { name: '', subject: 'Mensaje WEB',email: '', message: '' };

    // Validar nombre
    if (!formData.name.trim()) {
      errorsTemp.name = '*Este campo es requerido.';
      valid = false;
    }

    // Validar email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      errorsTemp.email = '*Este no es un email válido.';
      valid = false;
    }

    // Validar mensaje
    if (formData.message.length < 10) {
      errorsTemp.message = '*El mensaje es demasiado corto.';
      valid = false;
    }

    setErrors(errorsTemp);
    return valid;
  };

  // Manejar el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Obtén la respuesta de reCAPTCHA
    const captchaResponse = window.grecaptcha.getResponse();

    // Verifica que la respuesta no esté vacía
    if (!captchaResponse) {
      alert('Por favor, completa el reCAPTCHA.');
      return;
    }

    const data = {
      ...formData,
      'g-recaptcha-response': captchaResponse, // Añadir la respuesta del reCAPTCHA
    };

    try {
      const response = await fetch('https://www.ajesl.es:4433/contacto', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.ok) {
        alert(result.message); // Mostrar mensaje de éxito
        setFormData({ name: '', email: '', subject: '', message: '' }); // Limpiar el formulario
      } else {
        alert(result.error); // Mostrar mensaje de error
      }
    } catch (error) {
      alert('Error al enviar el formulario.');
    }
  };


  return (
    <>
      <div className="contenedor_registro_c">
        <div className="row justify-content-center col-12 col-md-12 principal">
          {/* Mapa */}
          <div className="col-10 col-lg-1 "></div>
          <div className='col-10 col-md-6 col-lg-3'>
          <div className='titulo_c text-center'>Mapa de Huelva</div> 
          <div className='justify-content-center preguntas'>
            <div className="map">
              <figure className="img-polaroid">
                <iframe
                  className='mapa'
                  src="https://maps.google.com/maps?f=q&source=s_q&hl=en&geocode=&q=Huelva,+Spain&aq=0&sll=37.261421,-6.944722&sspn=0.05,0.05&ie=UTF8&hq=&hnear=Huelva,+Spain&ll=37.261421,-6.944722&spn=0.05,0.05&z=14&iwloc=A&output=embed"
                  title="Google Maps Huelva"
                ></iframe>
              </figure>
            </div>
          </div></div>

          {/* Información de contacto */}
          <div className='row col-10 col-md-6 col-lg-3'>
          <div className='text-center'>
                <div className='titulo_c text-center'>Información de Contacto</div> 
          <div className="text-center preguntas">
            <div className="address">
              <strong className="lead">AJE,sl</strong>
              <br></br>
              <br></br>
              <p className="font-1">21004, Huelva.</p>
              Andalucía, España.<br />
              <br></br>
              <a href="mailto:web@ajesl.es" className="link">web@ajesl.es</a>
            </div>
          </div>
          </div>
          </div>
          {/* Formulario de contacto */}
          <div className='col-10 col-md-6 col-lg-3 text-center'>
                <div className='titulo_c text-center'>Formulario de Contacto</div> 
          <div className="preguntas">
            <h2></h2>
            <form id="contact-form" className="contact-form col-lg-10 text-center" onSubmit={handleSubmit} method="POST">
      {/* Nombre */}
      <label className="name text-center">
        <input
          className="etiqueta_c col-lg-12"
          type="text"
          name="name"
          placeholder="Nombre:"
          value={formData.name}
          onChange={handleChange}
          required
        />
        {errors.name && <span className="error">{errors.name}</span>}
      </label><br />

      {/* Email */}
      <label className="email">
        <input
          className="etiqueta_c col-lg-12"
          type="email"
          name="email"
          placeholder="E-mail:"
          value={formData.email}
          onChange={handleChange}
          required
        />
        {errors.email && <span className="error">{errors.email}</span>}
      </label><br />

      {/* Mensaje */}
      <label className="message">
        <textarea
          rows="4"
          className="etiqueta2 col-lg-12"
          name="message"
          placeholder="Comentario:"
          value={formData.message}
          onChange={handleChange}
          required
        />
        {errors.message && <span className="error">{errors.message}</span>}
      </label><br />

      {/* reCAPTCHA */}
      <div className='col-12 col-md-12 col-lg-12 justify-content-center'>
      <div className="recaptcha-container centrar">
  <div className="g-recaptcha text-center" data-size="compact" data-sitekey="6LfjwMYqAAAAAPow6kBsze7VSOoeIDX2lDThsPpF"></div>
      </div>
      </div>
      {/* Botón de enviar */}
      <button className="botonVerificar col-10" type="submit">Enviar</button>
    </form>
          </div></div>
          <div className="col-10 col-lg-1 "></div>
        </div>
      </div>
    </>
  );
}
export default Contacto;
